import { Form, Input } from "decorator-form";

import InputType from "common/form/InputType";
import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import ListOrderWidget from "common/form/widgets/listOrder/ListOrderWidget";

enum Views {
	MONTH = "month",
	WEEK = "week",
	DAY = "day",
	AGENDA = "agenda"
}

const viewOptions = [
	{ value: Views.MONTH, label: "Month" },
	{ value: Views.WEEK, label: "Week" },
	{ value: Views.DAY, label: "Day" },
	{ value: Views.AGENDA, label: "Agenda" }
];

const viewInput = ListOrderWidget.registerWithOptions(viewOptions, true);
const defaultViewInput = ButtonSelect.registerWithOptions(viewOptions);

@Form({title: "Calendar View Config"})
export default class CalendarViewConfig {

	@Input({type: InputType.UNIT, title: "Calendar Min Height"})
	public minHeight?: string = "500px";

	@Input({type: viewInput, title: "Views"})
	public views?: Views[];

	@Input({type: defaultViewInput, title: "Default View"})
	public defaultView?: Views;

	@Input({type: InputType.COLOR, title: "Event Background Color"})
	public eventBackgroundColor?: string;

	@Input({type: InputType.COLOR, title: "Event Text Color"})
	public eventColor?: string;

	@Input({type: InputType.COLOR, title: "Event Active Background Color"})
	public eventActiveBackgroundColor?: string;

	@Input({type: InputType.COLOR, title: "Current Date Cell Background"})
	public activeBackground?: string;

	@Input({type: InputType.COLOR, title: "Current Date Cell Text Color"})
	public activeColor?: string;

	@Input({type: InputType.COLOR, title: "Current Time Indicator Color"})
	public indicatorColor?: string;

}



// WEBPACK FOOTER //
// ./src/common/views/calendar/CalendarViewConfig.ts